import { createSlice, Reducer, Slice } from "@reduxjs/toolkit";

import AnnualSummaryTabSlice from "../../models/Redux/AnnualSummaryTabSlice.model";
import { AnnualSummarySelectedSlicerModel } from "../../models/TradeAndPromoPlanning/AnnualSummarySlicer.model";
import { ANNUAL_SUMMARY_TAB_ID } from "../../shared/constants";
import { getDefaultSlicersForForecastEntryApp } from "../../shared/functions";

const defaultSlicers: AnnualSummarySelectedSlicerModel = getDefaultSlicersForForecastEntryApp(ANNUAL_SUMMARY_TAB_ID);

const initialState: AnnualSummaryTabSlice = {
    tempSelectedSlicers: defaultSlicers,
    selectedSlicers: defaultSlicers, 
    slicers: {
        brand: [],
        subBrand: [],
        volumeSize: [],
        customer: []
    },
    hierarchy: 'Brand-SubBrand-VolumeSize'
};

const forecastComparisonTabSlice: Slice = createSlice({
    name: "annualSummaryTab",
    initialState,
    reducers: {
        setSlicers: (state, action) => {
            let temp:any = {};
            temp["brand"] = action.payload.brand;
            temp["subBrand"] = action.payload.subBrand;
            temp["volumeSize"] = action.payload.volumeSize;
            temp["customer"] = action.payload.customer;
            state.slicers = temp;
        },
        setTempSelectedSlicers: (state, action) => {
            state.tempSelectedSlicers = action.payload;
        },
        setSelectedSlicers: (state, action) => {
            state.selectedSlicers = action.payload;
        },
        setHierarchy: (state, action) => {
            state.hierarchy = action.payload;
        },
        resetSelectedSlicers: (state, action) => {
            state.tempSelectedSlicers = structuredClone(defaultSlicers);
            state.selectedSlicers = structuredClone(defaultSlicers);
            state.hierarchy = 'Brand-SubBrand-VolumeSize';
        }
    }
});

export const forecastComparisonTabActions = forecastComparisonTabSlice.actions;

export default forecastComparisonTabSlice.reducer as Reducer<AnnualSummaryTabSlice>;
